<template>
  <g
    class="layer-labels x-axis-authority-gap-label font-medium uppercase tracking-wider"
  >
    <g
      v-for="(p, i) in points"
      :key="'layer-label-' + i"
    >
      <line
        :x1="p.x"
        :x2="p.x + xposData"
        :y1="p.y"
        :y2="p.y + yposData"
        :stroke="colorData"
        stroke-width="1"
      ></line>
      <!-- <rect 
        :x="p.x + xposData - rectOffsetData"
        :y="p.y + yposData - 13.5" 
        rx="10"
        ry="10"
        width="70"
        height="20"
        :fill="colorData"
        >
      </rect> -->
      <text
        :key="i"
        :x="p.x + xposData"
        :y="p.y + yposData + 8"
        :text-anchor="xalignData"
        font-size="8"
        :fill="colorData"
        class="select-none"
      >
        {{ p.props.data[dataKeys[2]] }}
      </text>
      <!-- <circle 
        :cx="p.x"
        :cy="p.y"
        :fill="colorData"
        :r="2"
        :stroke-width="4"
        >
        <animate attributeName="r" attributeType="CSS" from="2" to="10" dur="1.5s" begin="0s" repeatCount="indefinite"/>
        <animate attributeName="opacity" attributeType="CSS" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite"/>
      </circle> -->
    </g>
  </g>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { usePoints } from 'vue3-charts';

export default defineComponent({
  name: 'LabelsInsightsAuthorityHistoryXAxis',
  props: {
    dataKeys: {
      // type: Object as () => [string, string],
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    xalign: {
      type: String,
      required: true,
    },
    xpos: {
      type: Number,
      required: true,
    },
    ypos: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { points } = usePoints(props.dataKeys);
    const colorData = ref(props.color);
    const xalignData = ref(props.xalign);
    const yposData = ref(parseFloat(props.ypos));
    const xposData = ref(parseFloat(props.xpos));
    const rectOffsetData = computed(function () {
      if (xalignData.value == 'left') {
        return 0;
      } else {
        return 35;
      }
    });
    return {
      points,
      colorData,
      xalignData,
      yposData,
      xposData,
      rectOffsetData,
    };
  },
});
</script>
